import { render, staticRenderFns } from "./BaseInternationalization.vue?vue&type=template&id=79cc97d4&scoped=true"
import script from "./BaseInternationalization.vue?vue&type=script&lang=js"
export * from "./BaseInternationalization.vue?vue&type=script&lang=js"
import style0 from "./BaseInternationalization.vue?vue&type=style&index=0&id=79cc97d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cc97d4",
  null
  
)

export default component.exports